//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { createFragmentContainer } from "react-relay";
// autopilot-feed-status-unstarted imports
import { IProps, IState } from "./AutopilotFeedStatusUnstarted.d";
import { autopilotFeedStatusUnstartedFragments } from "./AutopilotFeedStatusUnstarted.gql";
import { styles } from "../AutopilotFeedStatus.styles";
// util
import { getTimeZoneDisplayName } from "@clockwise/web-commons/src/util/time-zone.util";
import { getNextDefragText } from "@clockwise/client-commons/src/util/defrag";
// material-ui
import { Tooltip } from "@material-ui/core";
import { Assistant, ChevronRight, InfoOutlined, WarningOutlined } from "@material-ui/icons";
import withStyles from "@material-ui/core/styles/withStyles";
import { isError } from "@util/errorable.util";
import { TranslationContext } from "@clockwise/client-commons/src/providers/TranslationContext";

//////////////////
// COMPONENT
//////////////////
class AutopilotFeedStatusUnstartedCmpt extends React.Component<IProps, IState> {
  public static defaultProps = {
    isActionable: true,
  };

  constructor(props: IProps) {
    super(props);
  }

  static contextType = TranslationContext;
  declare context: React.ContextType<typeof TranslationContext>;

  public render() {
    const t = this.context;
    const { org, orgTimeZone, classes, isActionable } = this.props;

    const nextDefragTime =
      org.nextDefragTime.__typename !== "GraphEntityError" && org.nextDefragTime.millis;

    if (!nextDefragTime) {
      return null;
    }

    const meetings =
      org &&
      org.autopilotEventsResponse &&
      org.autopilotEventsResponse.__typename !== "GraphEntityError" &&
      org.autopilotEventsResponse.enabledAttending.concat(
        org.autopilotEventsResponse.enabledOrganized,
      );

    let meetingCount = 0;
    let pausedCount = 0;

    if (meetings) {
      meetingCount = meetings.length;
      pausedCount = meetings.filter((event) => event.paused).length;
    }

    const localRunTime = getNextDefragText(nextDefragTime, false);

    let title = t("autopilot-status:subtitle", { localRunTime });
    let tooltipText: string | JSX.Element | undefined = t("autopilot-status:tooltip", {
      timeZone: getTimeZoneDisplayName(orgTimeZone),
    });
    let description: JSX.Element | string | undefined = undefined;

    if (pausedCount > 0) {
      description = (
        <>
          <WarningOutlined className={classes.descriptionIcon} style={{ marginRight: 6 }} />
          {t("autopilot-status:paused")}
          {isActionable && <ChevronRight className={classes.descriptionChevronIcon} />}
        </>
      );
    } else if (meetingCount > 0) {
      description = <div>{t("autopilot-status:active", { count: meetingCount })}</div>;
    } else if (!org?.autopilotEventsResponse || isError(org.autopilotEventsResponse)) {
      description = "";
    } else {
      title = t("autopilot-status:empty");
      tooltipText = undefined;
    }

    const containerClass = this.props.isActionable ? "actionableContainer" : "container";

    const tooltip = tooltipText ? (
      <Tooltip placement="top" title={tooltipText} classes={{ popper: classes.popper }}>
        <InfoOutlined className={classes.infoIcon} />
      </Tooltip>
    ) : null;

    return (
      <div onClick={this.props.onClick} className={classes[containerClass]}>
        <Assistant className={description === undefined ? classes.basicIcon : classes.icon} />
        <div>
          <div className={description === undefined ? classes.basicStatus : classes.status}>
            {title}
            {title && tooltip}
          </div>
          {description && (
            <div className={pausedCount > 0 ? classes.errorDescription : classes.description}>
              {description}
              {!title && tooltip}
            </div>
          )}
        </div>
      </div>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
export const AutopilotFeedStatusUnstartedStyled = withStyles(styles)(
  AutopilotFeedStatusUnstartedCmpt,
);

//////////////////
// RELAY
//////////////////
export const AutopilotFeedStatusUnstarted = createFragmentContainer(
  AutopilotFeedStatusUnstartedStyled,
  autopilotFeedStatusUnstartedFragments,
);
